import { render, staticRenderFns } from "./Myorderdjd.vue?vue&type=template&id=a6e6c508&scoped=true&"
import script from "./Myorderdjd.vue?vue&type=script&lang=js&"
export * from "./Myorderdjd.vue?vue&type=script&lang=js&"
import style0 from "./Myorderdjd.vue?vue&type=style&index=0&id=a6e6c508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e6c508",
  null
  
)

export default component.exports